import { EntityUtils } from '@record-it-npm/synchro-client';
import { TimeTrackingConfiguration } from './timeTrackingConfigurationTypes';
export class TimeTrackingConfigurationUtils {
  public static displayTextGetter = (config: TimeTrackingConfiguration): string => config.name;
  public static keyGetter = (config: TimeTrackingConfiguration): string => EntityUtils.getTrackingKey(config);
}